import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/batch_run/batch_run/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'Delivery date', value: 'delivery_date', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Customer order', value: 'customer_order_title', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'Customer', value: 'customer_title', sortable: true, filterable: true, divider: true, brief: false,},

        {text: 'Status BR', value: 'status_br', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Plan SMD', value: 'plan_smd', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Plan THT', value: 'plan_tht', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'As is SMD', value: 'as_is_smd', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'As is THT', value: 'as_is_tht', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'S/N SMD from', value: 'sn_smd_from', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'S/N SMD to', value: 'sn_smd_to', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'S/N THT from', value: 'sn_tht_from', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'S/N THT to', value: 'sn_tht_to', sortable: true, filterable: true, divider: true, brief: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, brief: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, brief: true,},
        {text: 'Edited by*', value: 'edited_by_name', sortable: true, divider: true, brief: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
    statusDelivery: [
        {name: 'Vorbereitung', color: 'grey lighten-5'},
        {name: 'In Klärung', color: 'red lighten-5'},
        {name: 'Produktion', color: 'blue lighten-5'},
        {name: 'Lager', color: 'light-green lighten-5'},
        {name: 'Komplett ausgeliefert', color: 'grey lighten-5'},
        {name: 'Zurückgezogen', color: 'amber lighten-5'},
    ],
    statusBatchRun: [
        {name: 'Vorbereitung', color: 'grey lighten-5'},
        {name: 'In Klärung', color: 'red lighten-5'},
        {name: 'Produktion', color: 'blue lighten-5'},
        {name: 'Lager', color: 'light-green lighten-5'},
        {name: 'Komplett ausgeliefert', color: 'grey lighten-5'},
        {name: 'Zurückgezogen', color: 'amber lighten-5'},
    ],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
    getStatusCustomerOrder(state) {
        let result = []
        // for (let row of state.statusCustomerOrder)
        //     result.push(row.name)
        return result
    }
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        BatchRunTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}